let owners = 0
let previousRestoration = null

/* Wyłącznie nowy układ: przy odświeżeniu nie przywracamy dolnych kart,
 * zanim WebWave przeliczy wysokość strony. Nie wywołujemy scrollowania. */
export function disableOfferScrollRestoration() {
  const history = window.history
  if (!history || !('scrollRestoration' in history)) return () => {}
  if (owners === 0) previousRestoration = history.scrollRestoration
  owners++
  history.scrollRestoration = 'manual'
  let released = false
  return () => {
    if (released) return
    released = true
    owners--
    if (owners === 0 && history.scrollRestoration === 'manual') {
      history.scrollRestoration = previousRestoration
    }
  }
}
